var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedsSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 6.75V8.75L5.96 12.33C5.82 12.61 5.75 12.91 5.75 13.22V18.75C5.75 19.85 6.65 20.75 7.75 20.75H15.75C16.85 20.75 17.75 19.85 17.75 18.75V13.22C17.75 12.91 17.68 12.6 17.54 12.33L15.75 8.75V6.75M7.75 6.75H15.75M7.75 6.75C7.2 6.75 6.75 6.3 6.75 5.75V4.75C6.75 4.2 7.2 3.75 7.75 3.75H15.75C16.3 3.75 16.75 4.2 16.75 4.75V5.75C16.75 6.3 16.3 6.75 15.75 6.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.66 8.47L16.11 6.75H7.35L7.75 8.75L5.75 12.89L5.85 20.75H17.34V13.75L15.66 8.47ZM14.75 14.5H12.5V16.75C12.5 17.16 12.16 17.5 11.75 17.5C11.34 17.5 11 17.16 11 16.75V14.5H8.75C8.34 14.5 8 14.16 8 13.75C8 13.34 8.34 13 8.75 13H11V10.75C11 10.34 11.34 10 11.75 10C12.16 10 12.5 10.34 12.5 10.75V13H14.75C15.16 13 15.5 13.34 15.5 13.75C15.5 14.16 15.16 14.5 14.75 14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedsSolid);
export default __webpack_public_path__ + "static/media/meds-solid.bf87a767fa935ece1f3802f711315495.svg";
export { ForwardRef as ReactComponent };